import { Image, Text } from '@ui/atoms';
import React, { useState } from 'react';
import texts from '../en.json';
import useClient from '@hooks/useClient';
import ReactPlayer from 'react-player';

const YoutubeTestimonials = () => {
    const { isClient } = useClient();
    const [currentPlayingId, setCurrentPlayingId] = useState(null);

    const testimonials = [
        {
            id: 1,
            url: 'https://www.youtube.com/watch?v=9kTgisKwnwA',
        },
        {
            id: 2,
            url: 'https://www.youtube.com/watch?v=c0g__B--6xA',
        },
        {
            id: 3,
            url: 'https://www.youtube.com/watch?v=xXHZbApiFc8',
        },
    ];
    return (
        <div className="relative flex flex-col px-4 lg:px-16 gap-8 items-center bg-basicWhite pt-10 pb-12 md:py-16 xl:py-22">
            <div className="flex flex-col gap-3 md:gap-4 items-center">
                <Text
                    className="text-gray-500 md:text-gray-700 p5-medium md:p3-medium text-center"
                    content={texts.YoutubeTestimonialsDescription}
                />
                <Text
                    className="h4-regular md:h3-regular xl:h2-semibold text-gray-500"
                    content={`${texts.YoutubeTestimonialsTitlePart1} <br class="md:hidden"/><span class="h4-semibold md:h3-semibold xl:h2-semibold text-transparent bg-blue-gradient bg-clip-text">${texts.YoutubeTestimonialsTitlePart2}</span>`}
                    isInnerHtml
                />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10 w-full max-w-[1152px]">
                {testimonials.map((testimonial, index) => (
                    <div
                        className={`rounded-lg w-full h-[186px] md:h-[204px] overflow-hidden ${
                            testimonials.length % 2 === 1 &&
                            index === testimonials.length - 1
                                ? 'sm:col-span-2 sm:col-start-1 sm:mx-auto sm:max-w-[50%] lg:col-span-1 lg:col-start-auto lg:mx-0 lg:max-w-none'
                                : ''
                        }`}
                    >
                        {isClient ? (
                            <ReactPlayer
                                height={'100%'}
                                width="100%"
                                url={testimonial.url}
                                stopOnUnmount={true}
                                playing={currentPlayingId === testimonial.id}
                                controls={true}
                                onPlay={() =>
                                    setCurrentPlayingId(testimonial.id)
                                }
                            />
                        ) : null}
                    </div>
                ))}
            </div>
            <div className="absolute hidden md:block top-0 left-0 right-0 w-max xl:w-full overflow-hidden">
                <Image
                    src="/images/homepage/bg_waves.svg"
                    className="w-full h-auto object-cover"
                />
            </div>
        </div>
    );
};

export default YoutubeTestimonials;
